import { render, staticRenderFns } from "./BrScanAlert.vue?vue&type=template&id=7fe6a388&"
import script from "./BrScanAlert.vue?vue&type=script&lang=js&"
export * from "./BrScanAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports